import React, { Component } from 'react';
import classNames from 'classnames';
import { REACT_APP_API_BASE } from '../../config';
import SpinnerDots from '../../components/spinner/dots';
import Publications from '../../components/publications';
import withAuthProvider from '../../hoc/withAuthProvider';
import withFetch from '../../hoc/withFetch';
import './styles.scss';

class MyPublications extends Component {

    state = {
        isLoading: true,
        publications: null,
        message: null
    }
    
    async componentDidUpdate() {
        if (!this.props.isAuthenticated) return;

        if (this.state.publications) return;

        if (this.state.message) return;

        const res = await this.props.fetch(`${REACT_APP_API_BASE}/online/publication?skip=0&top=1000`);
        
        if (res.ok) {
            const responseJson = await res.json();
            const publicationsWithAccess = responseJson.publications.filter(f => f.userHasAccessToThisPublication);
            const publicationsWithoutAccess = responseJson.publications.filter(f => !f.userHasAccessToThisPublication);
            this.setState({
                isLoading: false,
                publications: [...publicationsWithAccess, ...publicationsWithoutAccess]
            });
        } else {
            this.setState({
                isLoading: false,
                message: '🔦 Vi kunde inte hitta något.'
            });
        }
    }
    
    render() {
        return (
            <section className={classNames({
                'my-publications': true,
                'my-publications--is-loading': this.state.isLoading
            })}>
                <div className="my-publications__wrapper">
                    <h1>Analyser & Insikter</h1>
                    <div className="my-publications__wrapper-inner">
                        <Publications publications={this.state.publications} />

                        {this.state.message &&
                            <p>{this.state.message}</p>
                        }
                    </div>
                </div>
                <SpinnerDots />
            </section>
        );
    }
}

export default withAuthProvider(withFetch(MyPublications));